import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { getLoginState } from '@/utils/business';
import { getOrigin } from '@/utils/tool';
import { getSafeRedirectUrl } from '@/utils/safeRedirect';

const useExpRedirect = () => {
  const router = useRouter();
  const { lang } = useTranslation('common');
  const isLogin = getLoginState();

  const origin = getOrigin();
  const doExperimentRedirect = useCallback((destUrl?: string, isInApp?: boolean, redirectUrl?: string) => {
    if (isLogin) {
      return destUrl;
    }
    const redirect_url = getSafeRedirectUrl(redirectUrl ?? (router?.query?.redirect_url as string));
    let url = `/${lang}/account/signup?redirect_url=${encodeURIComponent(redirect_url)}`;
    if (router?.query?.prompt) {
      url = `${url}&prompt=${router?.query?.prompt}`;
    }
    if (isInApp) {
      url = `${origin}/${lang}/account/login?redirect_url=${encodeURIComponent(redirect_url)}&tab=sign`; //login?redirect_url app命中正则
    }

    return url;
  }, []);

  return doExperimentRedirect;
};

export default useExpRedirect;
